/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { otto } from "./nexus.js";
import { domSync, type DomAsync as DomAsync, type DomSync } from "../globals/dom.js";

/**
 *
 *
 *
 */
export const stringToDocumentFragment: DomSync["stringToDocumentFragment"] =
  domSync.stringToDocumentFragment;

/**
 *
 *
 *
 */
export const getFirstElementByTagName: DomSync["getFirstElementByTagName"] =
  domSync.getFirstElementByTagName;

/**
 *
 *
 *
 */
export const getHeadElement: DomSync["getHeadElement"] = domSync.getHeadElement;

/**
 *
 *
 *
 */
export const getBodyElement: DomSync["getBodyElement"] = domSync.getBodyElement;

/**
 *
 */
export const domAsync: DomAsync = otto.dom;

/**
 *
 */
export const dom = domSync;

/**
 *
 *
 *
 *
 */
export const onLoad: DomAsync["onLoad"] = domAsync.onLoad;

/**
 *
 *
 *
 *
 */
export const onReady: DomAsync["onReady"] = domAsync.onReady;

/**
 *
 *
 *
 */
export const onMount: DomAsync["onMount"] = domAsync.onMount;

/**
 *
 *
 *
 */
export const onUnmount: DomAsync["onUnmount"] = domAsync.onUnmount;

/**
 *
 *
 *
 *
 */
export const insertHtmlFragment: DomAsync["insertHtmlFragment"] = domAsync.insertHtmlFragment;

/**
 *
 *
 *
 *
 */
export const activateInlineScripts: DomAsync["activateInlineScripts"] =
  domAsync.activateInlineScripts;
